<template>
  <v-container class="reports-page" fluid>
    <div class="reports-header">
      <h1 class="reports-header__title">Бизнес отчёты</h1>
      <div class="reports-header__actions">
        <v-btn
          v-if="$canRoute('Doorphone')"
          color="primary"
          outlined
          class="reports-header__btn text-none"
          dark
          rounded
          @click="returnDoorphones"
        >
          <v-icon left>mdi-doorbell-video</v-icon>
          Домофоны
        </v-btn>
      </div>
    </div>

    <div class="reports-tabs-wrap mt-3">
      <v-tabs v-model="activeTab" class="reports-tabs" grow>
        <v-tab
          v-for="tab in visibleTabs"
          :key="tab.name"
          class="reports-tab"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="activeTab" class="reports-tabs-items">
      <v-tab-item
        v-for="tab in visibleTabs"
        :key="tab.name"
      >
        <v-card class="reports-block mt-0" flat outlined>
          <div class="reports-tab-content pa-4">
            <component :is="tab.component" />
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GeneralIndicators from '@/components/reports/BaseGeneralIndicators';
import GeneralReports from '@/components/reports/BaseGeneralReports';
import ReportsCodesHistoryTab from '@/components/reports/ReportsCodesHistoryTab.vue';
import DoorphoneAdMetricsPanel from '@/components/reports/DoorphoneAdMetricsPanel.vue';

export default {
  name: 'Reports',
  data () {
    return {
      activeTab: 0,
    };
  },
  created () {},
  mounted () {
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
    }),
    tabs () {
      return [
        {
          name: 'Общие показатели',
          component: GeneralIndicators,
          route: 'GeneralIndicator',
          show: true,
        },
        {
          name: 'Отчёты',
          component: GeneralReports,
          route: 'GeneralReport',
          show: true,
        },
        {
          name: 'Метрики рекламы',
          component: DoorphoneAdMetricsPanel,
          route: 'ReportDoorphoneAdMetrics',
          show: true,
        },
        {
          name: 'Журнал кодов',
          component: ReportsCodesHistoryTab,
          routes: ['ReportTempCodeProvisionHistory', 'ReportServiceDoorCodeHistory'],
          show: true,
        },
      ];
    },
    visibleTabs () {
      return this.tabs.filter((tab) => {
        if (!tab.show) {
          return false;
        }
        if (tab.routes && tab.routes.length) {
          if (!tab.routes.some((route) => this.$canRoute(route))) {
            return false;
          }
        } else if (tab.route && !this.$canRoute(tab.route)) {
          return false;
        }
        if (tab.permission && !this.$checkPermission(tab.permission)) {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
    ...mapActions({
    }),
    returnDoorphones () {
      this.$router.push({ name: 'Doorphone' });
    },
  },
};
</script>

<style lang="scss" scoped>
.reports-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.reports-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.reports-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.reports-header__btn {
  text-transform: none;
  font-weight: 500;
}

.reports-tabs-wrap {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px 12px 0 0;
  border-bottom: none;
  overflow: hidden;
}

.reports-tabs {
  box-shadow: none;
}

.reports-tabs ::v-deep .v-tabs-bar {
  background: transparent;
  height: 48px;
}

.reports-tabs ::v-deep .v-tab {
  text-transform: none;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #546e7a;
  min-height: 48px;
}

.reports-tabs ::v-deep .v-tab--active {
  color: #1976d2;
}

.reports-tabs ::v-deep .v-tabs-slider {
  color: #1976d2;
  height: 3px;
}

.reports-tabs ::v-deep .v-tab:not(.v-tab--active):hover {
  color: #37474f;
}

.reports-tabs-items {
  background: transparent;
}

.reports-block {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
}

.reports-tab-content {
  min-height: 200px;
}
</style>
